import React from 'react';
import { Redirect } from 'react-router-dom';
import { useQuery, Loading, Error, SelectInput, required } from 'react-admin';

const LocationField = () =>{

    let locations =  [];

    const { data, loading, error } = useQuery({
        type: 'getList',
        resource: 'userlocations',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            sort: { field: 'location', order: 'ASC' }
        }
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    locations = data;
    //console.log(data)
    return (
        <SelectInput source="branch_code"  disabled   label="Location" choices={locations} validate={required()} />
        )
}

export default LocationField